<template>
  <div class="page_ table_textc">
    <div  style="margin-bottom:60px;">
      <a-form layout="inline">
        <a-form-item label="保单号 ">
          <a-input
            class="min_input_"
            style="width: 200px;"
            v-model="policyNoi"
            placeholder="请输入保单号"
          ></a-input>
        </a-form-item>
        <a-form-item label="保险起/止日期">
          <a-range-picker
            :placeholder="['请选择日期', '请选择日期']"
            style="width: 215px;"
            @change="rangeDate"
            :value="createValue"
          ></a-range-picker>
        </a-form-item>
        <!-- <a-form-item label="投保人">
          <a-input
            class="min_input_"
            v-model="holderNamei"
            style="width: 100px;"
          ></a-input>
        </a-form-item> -->
        
        <a-form-item label="投保起/止日期">
          <a-range-picker
            :placeholder="['请选择日期', '请选择日期']"
            style="width: 215px;"
            @change="rangeDate1"
            :value="createValue1"
          ></a-range-picker>
        </a-form-item>
        <a-form-item label="下级账号">
          <a-select
            show-search
            placeholder="请选择"
            option-filter-prop="children"
            v-model="agencyId"
            style="width: 143px"
            :filter-option="filterOption"
          >
            <a-select-option v-for="(item,index) in lowerAccOptions" :key="index+'l'" :value="item.agencyId">
              {{item.agencyName}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="float:right;margin:8px 0 0 0">
          <a-button type="primary" @click="searchData()">查询</a-button>
          <a-button style="margin-left: 8px;" type="default" @click="initData()"
            >重置</a-button
          >
          <a-button
            style="margin-left: 8px;"
            type="default"
            @click="exportData()"
            >导出</a-button
          >
        </a-form-item>
      </a-form>
    </div>
    <a-table
      style="margin-top: 17px;"
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="handlePageChange"
      class="table_b table_nowrap table_nowrapg"
    >
      <span slot="operation" slot-scope="text, record" class="span_btn">
        <a href="javascript:void(0);" @click="goDetail(record.key)">保单详情</a>
      </span>
      <span slot="status" slot-scope="text, record" class="span_btn">
        {{ text | filterType(statusOptions) }}
      </span>
    </a-table>
    <div class="fixbg_" v-if="showDetail" @click="closeFix()">
      <div class="fixcon" @click.stop v-if="step === 1">
        <p>查看保单详情</p>
        <span class="close_" @click.stop="closeFix()"></span>
        <div class="detail">
          <div class="table_">
            <table>
              <tr>
                <td colspan="6" class="bold">保单信息</td>
              </tr>
              <tr>
                <td>保单号：</td>
                <td>{{ policyDetail.policyInfo.policyNo }}</td>
                <td>生效日期：</td>
                <td>
                  {{ policyDetail.policyInfo.effectiveDate | filterNull() }}
                </td>
                <td>终保日期：</td>
                <td>{{ policyDetail.policyInfo.expireDate | filterNull() }}</td>
              </tr>
              <tr>
                <td>保单状态：</td>
                <td>
                  {{
                    policyDetail.policyInfo.status | filterType(statusOptions)
                  }}
                </td>
                <td>保费：</td>
                <td>{{ policyDetail.policyInfo.totalPremium }}</td>
                <td>目的地：</td>
                <td>{{ policyDetail.policyInfo.destination }}</td>
              </tr>
            </table>
          </div>

          <div class="table_ ov_s">
            <table>
              <tr>
                <td colspan="12" class="bold">被保人信息</td>
              </tr>
              <tr>
                <th>被保人名称</th>
                <th>证件类型</th>
                <th>证件号码</th>
                <th>手机号</th>
                <th>投保人</th>
                <th>重疾保障</th>
                <th>重疾保障份数</th>
                <th>意外险份数</th>
                <th>保费（元）</th>
              </tr>
              <tr v-for="(itemp, indexp) in policyDetail.policyInsuredVoList" :key="indexp+'p'">
                <td>{{ itemp.name }}</td>
                <td>{{ itemp.idType | filterIdType(idTypeOptions) }}</td>
                <td>{{ itemp.idNumber }}</td>
                <td>{{ itemp.mobile }}</td>
                <td>{{ policyDetail.policyHolder.name }}</td>
                <td>{{ itemp.dutyVOs[0].dutyCode | filterdutyType }}</td>
                <td>{{ itemp.dutyVOs[0].purchaseNo }}</td>
                <td>{{ itemp.dutyVOs[1]?itemp.dutyVOs[1].purchaseNo:0 }}</td>
                <td>{{policyDetail.policyInfo.totalPremium}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="fixbg1" v-if="isLoagding">
      <a-spin />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import api from "@/utils/api";
import dictOptions from "../policy/dictOptions";
import { getLogined, getToken, getUserInfo } from "@/utils/authorized";
const columns = [
  {
    title: "保单号",
    key: "policyInfo.policyNo",
    dataIndex: "policyInfo.policyNo",
    width: 150,
  },
  {
    title: "产品名称",
    key: "policyInfo.productName",
    dataIndex: "policyInfo.productName",
  },
  {
    title: "保费",
    key: "policyInfo.totalPremium",
    dataIndex: "policyInfo.totalPremium",
  },
  {
    title: "投保人",
    key: "policyHolder.name",
    dataIndex: "policyHolder.name",
  },
  {
    title: "起保日期",
    key: "policyInfo.effectiveDate",
    dataIndex: "policyInfo.effectiveDate",
  },
  {
    title: "终保日期",
    key: "policyInfo.expireDate",
    dataIndex: "policyInfo.expireDate",
  },
  {
    title: "保单状态",
    key: "policyInfo.status",
    dataIndex: "policyInfo.status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "1",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    document.title = "已出单保单";
    return {
      columns,
      agencyId:'', //下级账号id
      lowerAccOptions:[],
      tableData: [],
      showDetail: false,
      dateFormat: "YYYY-MM-DD",
      pagination: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
      },
      expTotal: 10,
      policyDetail: {},
      step: 1,
      policyId: "",
      policyNo: "",
      status: 1,
      pageNum: 1,
      pageSize: "10",
      statusOptions: [
        {
          type: "1",
          name: "投保成功",
        },
        {
          type: "2",
          name: "已退保",
        },
      ],
      idTypeOptions: dictOptions.gdIdTypeOptions1,
      idTypeOptions1: dictOptions.guardianIdOptions,
      sexOptions: [
        {
          name: "男",
          value: "M",
        },
        {
          name: "女",
          value: "F",
        },
      ],
      typeOptions: [
        {
          name: "个人",
          value: "I",
        },
        {
          name: "企业",
          value: "C",
        },
      ],
      userName: "",
      isLoagding: false,
      errorMsg: "",
      createValue: [],
      createValue1: [],
      policyNoi: "",
      startCreateDate: '',
      endCreateDate: '',
      startDatei: "",
      endDatei: "",
      holderNamei: "",
    };
  },
  filters: {
    filterdutyType(val) {
      if (val == "zjjc") {
        return "基础";
      } else if (val == "zjsj") {
        return "升级";
      }
    },
    filterType: (val, statusOptions) => {
      if (!val || val === "" || val === undefined) {
        return "";
      } else {
        let typeName = "";
        statusOptions.map((item) => {
          if (item.type == val) {
            typeName = item.name;
          }
        });
        return typeName;
      }
    },
    filterIdType: (val, idTypeOptions) => {
      if (!val || val === "" || val === undefined) {
        return "";
      } else {
        let idName = "";
        idTypeOptions.map((item) => {
          if (item.value == val) {
            idName = item.name;
          }
        });
        return idName;
      }
    },
    filterSex: (val, sexOptions) => {
      if (!val) {
        return "";
      } else {
        let idName = "";
        sexOptions.map((item) => {
          if (item.value == val) {
            idName = item.name;
          }
        });
        return idName;
      }
    },
    filterNull: (val) => {
      if (!val || val === "" || val === undefined) {
        return val;
      } else {
        return val.substring(0, 10);
      }
    },
  },
  mounted() {
    if (getUserInfo() && getUserInfo().userName) {
      this.userName = getUserInfo().userName;
      this.queryNextAgencies()
      this.initData();
    } else {
      this.$router.push({
        name: "gd-login",
      });
    }
  },
  methods: {
    moment,
    handlelowerChange(val){
      
    },
    queryNextAgencies() {
      let data = {
        userName: this.userName
      }
      api.queryNextAgencies(data).then(res => {
        this.lowerAccOptions = res.data.agencys
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlePageChange(e) {
      console.log(e, "e======>");
      this.pageNum = e.current;
      this.searchData();
    },
    initData() {
      this.policyNoi = "";
      this.createValue = [];
      this.startCreateDate = ''
      this.endCreateDate = ''
      this.startDatei = "";
      this.endDatei = "";
      this.holderNamei = "";
      this.agencyId = ''
      let queryData = {
        userName: this.userName,
        startIndex: 1,
        pageSize: 10,
      };
      this.queryData(queryData);
    },
    exportData() {
      let data = {
        // userName: getUserInfo().userName,
        // startIndex: 1,
        // pageSize: this.expTotal,
        startCreateDate: this.startCreateDate,
        endCreateDate: this.endCreateDate,
        userName: this.userName,
        policyNo: this.policyNoi,
        startDate: this.startDatei,
        endDate: this.endDatei,
        holderName: encodeURI(this.holderNamei),
        agencyId:this.agencyId,
        startIndex: (this.pageNum-1)*10+1,
        pageSize: 10,
      };
      this.isLoagding = true;
      api
        .exportExcelInsured(data)
        .then((res) => res.data)
        .then((data) => {
          this.isLoagding = false;
          let blob = new Blob([data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let url = window.URL.createObjectURL(blob);
          let aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.setAttribute("download", "excel.xls");
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
          window.URL.revokeObjectURL(url);
        });
    },
    queryData(queryData) {
      this.isLoagding = true;
      api
        .queryGdPolicy(queryData)
        .then((res) => res.data)
        .then((data) => {
          this.isLoagding = false;
          this.tableData = data.policyList.map((item, index) => {
            item.key = index;
            item.policyInfo.effectiveDate = item.policyInfo.effectiveDate.substring(
              0,
              10
            );
            item.policyInfo.expireDate = item.policyInfo.expireDate.substring(
              0,
              10
            );
            return item;
          });

          console.log(this.tableData,"--->this.tableData")
          this.pagination.total = data.total;
          this.expTotal = data.total;
        })
        .catch((error) => {
          this.isLoagding = false;
          if(error.data){
             this.errorMsg = error.data.msg;
          } else if (error.data.returnMsg){
            this.errorMsg = error.data.returnMsg;
          }
         
        });
    },
    searchData() {
      let queryData = {
        userName: this.userName,
        policyNo: this.policyNoi,
        startDate: this.startDatei,
        endDate: this.endDatei,
        startCreateDate: this.startCreateDate,
        endCreateDate: this.endCreateDate,
        holderName: encodeURI(this.holderNamei),
        agencyId:this.agencyId,
        startIndex: (this.pageNum-1)*10+1,
        pageSize: 10,
      };
      console.log(queryData, "queryData");
      this.queryData(queryData);
    },
    rangeDate(dates, dateStrings) {
      this.createValue = dates;
      this.startDatei = dateStrings[0];
      this.endDatei = dateStrings[1];
    },
    rangeDate1(dates, dateStrings) {
      this.createValue1 = dates;
      this.startCreateDate = dateStrings[0];
      this.endCreateDate = dateStrings[1];
    },
    goDetail(key) {
      console.log(key, "key----");
      this.showDetail = true;
      this.policyDetail = this.tableData[key];
    },
    closeFix() {
      this.showDetail = false;
    },
    getUrl(record) {
      console.log(record, "---<record");
      window.open(record.policyInfo.epolicyUrl);
    },
    sureSurrender() {
      let postData = this.policyDetail;
      if (moment().isBefore(this.policyDetail.policyInfo.effectiveDate)) {
        postData.flag = "1";
        postData.operateType = "02";
        postData.orderType =
          this.policyDetail.policyInfo.policyType === "2" ? "1" : "0";
        postData.policyInsuredVoList = postData.policyInsuredList;
        if (postData.policyInsuredList) {
          delete postData.policyInsuredList;
        }
        api.changeOrder(postData).then((res) => {
          if (res.data.returnCode === "00") {
            this.$message.info("撤单成功", 3);
            this.initData();
          } else {
            this.$message.warning(res.data.returnMsg, 3);
          }
          this.showDetail = false;
        });
      } else {
        this.$message.warning("该保单已生效，不支持撤单");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.min_input_ {
  width: 64px;
}
.span_btn {
  a {
    color: #ff4c1c;
    margin-right: 8px;
    text-decoration: none;
    &:last-child {
      margin-right: 0;
    }
  }
}
.fixbg_ {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  .fixcon {
    background-color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 960px;
    margin: 0 auto;
    max-height: 50vh;
    overflow-y: hidden;
    padding-top: 50px;
    padding-bottom: 40px;
    top: 50%;
    transform: translateY(-50%);
    & > p {
      font-weight: bold;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      margin: 0;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      margin: 0 auto;
      padding: 0 20px;
    }
    .close_ {
      width: 30px;
      height: 30px;
      background: url(../../../assets/wxmall/closeicon.png) center center
        no-repeat;
      background-size: 30px 30px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }
    .detail {
      position: absolute;
      left: 0;
      right: 0;
      padding: 0 20px;
      bottom: 50px;
      top: 50px;
      overflow-y: scroll;
      .table_ {
        margin-bottom: 30px;
        width: 100%;
        &.ov_s {
          width: 100%;
          overflow-x: scroll;
          table {
            min-width: 100%;
            th,
            td {
              white-space: nowrap;
            }
          }
        }
      }
      table {
        min-width: 100%;
        border: 1px solid #f2f2f2;
        border-collapse: collapse;
        table-layout: fixed;
        th,
        td {
          padding: 10px;
          border: 1px solid #f2f2f2;
        }
      }
      .bold {
        font-weight: bold;
      }
    }
    .btn_b {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      padding: 5px 0;
      button {
        width: 100px;
        height: 40px;
        line-height: 40px;
        background-color: #ff4c1c;
        color: #fff;
        text-align: center;
        border: none;
        outline: none;
        border-radius: 4px;
        display: block;
        margin: 0 auto;
        font-size: 16px;
        padding: 0;
      }
    }
    .forminfo_ {
      display: flex;
      flex-direction: row;
      .infoitem {
        display: flex;
        flex: 1;
        margin-bottom: 20px;
        &.fl_2 {
          flex: 2;
          input {
            width: 200px;
          }
        }
        input {
          border: 1px solid #d9d9d9;
          background-color: transparent;
          width: 95px;
          padding-left: 5px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
        }
        select {
          width: 100px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
        span {
          white-space: nowrap;
          margin-right: 5px;
          width: 65px;
          text-align: left;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
}
.table_b {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}
</style>
